import EventEmitter from 'events';
import router from '../router';
import config from '../config/index';
import { getProfile } from '../api/user';
import { getToken, clearToken } from '../utils/tools';

// 'loggedIn' is used in other parts of application. So, Don't forget to change there also
const localStorageKey = 'loggedIn';

const tokenExpiryKey = 'tokenExpiry';
const loginEvent = 'loginEvent';
const userInfo = 'judgeInfo';

class AuthService extends EventEmitter {
    profile = null;
    tokenExpiry = null;

    // Starts the user login flow
    login(customState) {
        // webAuth.authorize({
        //     appState: customState
        // });
    }

    // Handles the callback request from Auth0
    handleAuthentication() {
        let that = this
        return new Promise((resolve, reject) => { 
            getProfile({
                access_token: getToken()
            }).then((res) => {
                that.localLogin(res.data)
                resolve(res.data)
            }, (err) => {
                alert(err + '. Detailed error can be found in console.');
                reject(err)
            })
        })
    }

    localLogin(authResult) {
        this.profile = authResult.info;

        if (this.profile.user_role !== 'judge') {
            clearToken()
            alert('没有权限，请使用正确的评委账号登录！')
            return
        }
        localStorage.setItem('userRole', this.profile.user_role)

        // Convert the JWT expiry time from seconds to milliseconds
        this.tokenExpiry = new Date(this.profile.exp * 1000);
        localStorage.setItem(tokenExpiryKey, this.tokenExpiry);
        localStorage.setItem(localStorageKey, 'true');
        localStorage.setItem(userInfo, JSON.stringify({
            displayName: this.profile.nickname,
            username: this.profile.username,
            email: this.profile.email,
            phone: this.profile.phone,
            photoURL: this.profile.picture,
            providerId: this.profile.id,
            uid: this.profile.id,
            motto: this.profile.motto,
            registerTime: this.profile.register_time
        }));

        this.emit(loginEvent, {
            loggedIn: true,
            profile: authResult.idTokenPayload,
            state: authResult.appState || {}
        });
    }

    renewTokens() {
        let that = this
        // reject can be used as parameter in promise for using reject
        return new Promise((resolve, reject) => { 
            if (getToken()) {
                getProfile({
                    access_token: getToken()
                }).then((res) => {
                    that.localLogin(res.data)
                    resolve(res.data)
                }, (err) => {
                    alert(err + '. Detailed error can be found in console.');
                    reject(err)
                })
            }
        })
    }

    logOut() {
        localStorage.removeItem(localStorageKey);
        localStorage.removeItem(tokenExpiryKey);
        localStorage.removeItem(userInfo);

        this.tokenExpiry = null;
        this.profile = null;

        this.emit(loginEvent, { loggedIn: false });
    }

    isAuthenticated() {
        if (new Date(Date.now()) < new Date(localStorage.getItem(tokenExpiryKey)) &&
        localStorage.getItem(localStorageKey) === 'true' && localStorage.getItem(config.accessToken)) {
            return true;
        }
        this.logOut()
        return false;
    }
}

export default new AuthService();
